module.exports = __webpack_public_path__ + "img/icon-info.5e89d6fc.svg";